import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function YasamTarziTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['yasam-tarzi-testleri']} />;
}
